(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement"]) return;
  try {
    
  document.addEventListener('shopify:section:load', function (event) {
    if (!window.Trustpilot || typeof window.Trustpilot.loadFromElement !== 'function') return;
    event.target.querySelectorAll('.announcement-trustpilot .trustpilot-widget').forEach(function (widget) {
      window.Trustpilot.loadFromElement(widget);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
